import { render } from "./SalesForm.vue?vue&type=template&id=5ee05f6c&scoped=true"
import script from "./SalesForm.vue?vue&type=script&lang=js"
export * from "./SalesForm.vue?vue&type=script&lang=js"

import "./SalesForm.vue?vue&type=style&index=0&id=5ee05f6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee05f6c"]])

export default __exports__